export const systemManagementMenuDef = [
  {
    "name": "menu.system_settings",
    "icon": "fa fa-tags",
    "data": {
      "nav_url": "valueset_karexpert_m"
    },
    "children": [
      {
        name: 'menu.growth_chart_master',
        check_permission: false,
        showMenu: false,
        resource: 'growth_chart_master',
        url: 'growth_chart_master',
        auto_crud: true
     },
      {
        name: 'menu.serviceType_module_mapping',
        icon: 'fa fa-calendar',
        resource: 'serviceType_module_mapping',
        url: 'serviceType_module_mapping',
        auto_crud: true,
        breadcrumb: 'serviceType_module_mapping',
      },
      {
        name: 'menu.key_definition',
        icon: 'fa fa-calendar',
        resource: 'key_definition',
        url: 'key_definition',
        auto_crud: true,
        breadcrumb: 'key definition',
      },
      {
        "name": "System ValueSet",
        "resource": "system_valueset",
        "icon": "fa fa-tag",
        "url": "system_valueset",
        "auto_crud": true
      },
      {
        "name": "Industry",
        "resource": "industry",
        "icon": "fa fa-tag",
        "url": "industry",
        "auto_crud": true
      },
      {
        "name": "ValueSets",
        "resource": "valueset",
        "icon": "fa fa-tag",
        "url": "valueset",
        "auto_crud": true
      },
      {
        "name": "menu.karexpert",
        "resource": "valueset_karexpert",
        "icon": "fa fa-tag",
        "url": "valueset_karexpert",
        "auto_crud": true
      },
      {
        "name": "menu.accountValueset",
        "resource": "account_valueset_karexpert",
        "icon": "fa fa-tag",
        "url": "account_valueset_karexpert",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.crm",
        "resource": "valueset_crm",
        "icon": "fa fa-tag",
        "url": "valueset_crm",
        "auto_crud": true
      },
      {
        "name": "menu.snomed",
        "resource": "valueset_snomed",
        "icon": "fa fa-tag",
        "url": "valueset_snomed",
        "auto_crud": true
      },
      {
        "name": "menu.loinc",
        "resource": "valueset_loinc",
        "icon": "fa fa-tag",
        "url": "valueset_loinc",
        "auto_crud": true
      },
      {
        "name": "menu.cpt",
        "resource": "valueset_cpt",
        "icon": "fa fa-tag",
        "url": "valueset_cpt",
        "auto_crud": true
      },
      {
        "name": "menu.folder_master",
        "resource": "folder_document",
        "icon": "fa fa-tag",
        "url": "folder_document",
        "auto_crud": true,
        "breadcrumb": "Folder Master",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.machine_config_master",
        "resource": "machine_config_master",
        "icon": "fa fa-user-md",
        "url": "machine_config_master",
        "auto_crud": true,
        "breadcrumb": "Machine config Master",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.country",
        "resource": "country",
        "icon": "fa fa-tag",
        "url": "country",
        "auto_crud": true,
        "breadcrumb": "Country",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.country_language",
        "resource": "country_language_hidden",
        "icon": "fa fa-tag",
        "url": "country_language_hidden",
        "auto_crud": true,
        "breadcrumb": "Country Language",
        "check_permission": false,
        "showMenu": true
      },

      {
        "name": "menu.config_master",
        "resource": "config_master",
        "icon": "fa fa-tag",
        "url": "config_master",
        "auto_crud": true,
        "breadcrumb": "Config Master",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.care_flag_master",
        "resource": "care_flag_master",
        "icon": "fa fa-tag",
        "url": "care_flag_master",
        "auto_crud": true,
        "breadcrumb": "Care Flag Master",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.localization_master",
        "resource": "localization_master",
        "icon": "fa fa-tag",
        "url": "localization_master",
        "auto_crud": true,
        "breadcrumb": "Localization Master",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.third_party_app_credentials",
        "resource": "third_party_app_credentials",
        "icon": "fa fa-tag",
        "url": "third_party_app_credentials",
        "auto_crud": true,
        "breadcrumb": "Third Party App Credentials",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.address_master_fields",
        "resource": "address_field_master",
        "icon": "fa fa-tag",
        "url": "address_field_master",
        "auto_crud": true,
        "breadcrumb": "Address Master Fields",
        "check_permission": true,
        "showMenu": true
      },

      {
        "name": "menu.create_address_template",
        "resource": "address_template",
        "icon": "fa fa-tag",
        "url": "address_template",
        "auto_crud": true,
        "breadcrumb": "Create AddressT Template",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.address_dependent_fields",
        "resource": "address_dependent_fields",
        "icon": "fa fa-tag",
        "url": "address_dependent_fields",
        "auto_crud": true,
        "breadcrumb": "Address Dependent Fields",
        "check_permission": true,
        "showMenu": true
      },

      {
        "name": "menu.service_type_stage_mapping",
        "resource": "service_type_stage_mapping",
        "icon": "fa fa-tag",
        "url": "service_type_stage_mapping",
        "auto_crud": true,
        "breadcrumb": "Service Type Stage Mapping",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.clearance_stage_master",
        "resource": "clearance_stage_master",
        "icon": "fa fa-tag",
        "url": "clearance_stage_master",
        "auto_crud": true,
        "breadcrumb": "Clearance Stage Master",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.audit_diff_config",
        "resource": "audit_diff_config",
        "icon": "fa fa-tag",
        "url": "audit_diff_config",
        "auto_crud": true,
        "breadcrumb": "Audit Diff Config",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.surgery_time_master",
        "resource": "surgery_time_master",
        "icon": "fa fa-tag",
        "url": "surgery_time_master",
        "auto_crud": true,
        "breadcrumb": "Surgery Time Master",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.bed_stage_master",
        "resource": "bed_stage_master",
        "icon": "fa fa-tag",
        "url": "bed_stage_master",
        "auto_crud": true,
        "breadcrumb": "Bed Stage Master",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.stage_action",
        "resource": "stage_action",
        "icon": "fa fa-tag",
        "url": "stage_action",
        "auto_crud": true,
        "breadcrumb": "Stage Action",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.widget_config",
        "resource": "widget_config",
        "icon": "fa fa-tag",
        "url": "widget_config",
        "auto_crud": true,
        "breadcrumb": "Widget Config",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.create_dashboard",
        "resource": "dashboard_master_list",
        "icon": "fa fa-tag",
        "url": "dashboard_master_list",
        "auto_crud": true,
        "breadcrumb": "Create Dashboard",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": 'menu.template_high_level_request_master',
        "resource": 'high_level_request_master',
        "icon": 'fa fa-h-square',
        "url": 'high_level_request_master',
        "breadcrumb": "high_level_request_master",
        "auto_crud": true
      },
      {
        "name": "menu.address_data",
        "resource": "address_data",
        "icon": "fa fa-tag",
        "url": "address_data",
        "auto_crud": true,
        "breadcrumb": "Address Master",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.city",
        "resource": "city",
        "icon": "fa fa-tag",
        "url": "city",
        "auto_crud": true,
        "breadcrumb": "City",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.state",
        "resource": "state",
        "icon": "fa fa-tag",
        "url": "state",
        "auto_crud": true,
        "breadcrumb": "State",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.country",
        "resource": "country",
        "icon": "fa fa-tag",
        "url": "country",
        "auto_crud": true,
        "breadcrumb": "Country",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.translation",
        "resource": "translation",
        "icon": "fa fa-tag",
        "url": "translation",
        "auto_crud": true,
        "breadcrumb": "Translation Master",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.unit_conversion",
        "resource": "unit_conversion",
        "icon": "fa fa-tag",
        "url": "unit_conversion",
        "auto_crud": true,
        "breadcrumb": "Unit Conversion Master",
        "check_permission": false,
        "showMenu": true
      },
      {
          name: 'Archive Metadata',
          resource: 'archive_metadata',
          icon: 'fa fa-tag',
          url: 'archive_metadata',
          auto_crud: true
      },
      {
        "name": "menu.icd_o_diagnosis_valueset",
        "resource": "icd_o_diagnosis_valueset",
        "icon": "fa fa-tag",
        "url": "icd_o_diagnosis_valueset",
        "auto_crud": true
      },
      {
        name: 'menu.master_key',
        icon: 'fa fa-tag',
        resource: 'master_key',
        url: 'master_key',
        auto_crud: true,
        breadcrumb: 'Master Key',
      },
      {
        name: 'menu.emr_code_mapping',
        resource: 'emr_code_mapping',
        icon: 'fa fa-tag',
        url: 'emr_code_mapping',
        auto_crud: true
    },
    ]
  }

]